import { type FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const BIOSIMILAR_CONVERSION_IN_PROGRESS_MESSAGE = 'Conversion already in progress';

export const getConvertBiosimilarErrorMessage = (err: FetchBaseQueryError | { status?: number }) =>
    err?.status === 409
        ? BIOSIMILAR_CONVERSION_IN_PROGRESS_MESSAGE
        : 'Unable to convert biosimilar. Please try again.';
